import { Component, OnInit } from '@angular/core';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { WindowService } from 'src/shared/providers/window.service';

/**
 * "Edit Subscription" — the two subscription changes TIDY handles by hand rather than
 * self-serve. Both hand the concierge chat a drafted message and stop there: the client
 * still has to press send, so nothing is requested by accident.
 *
 * Neither is a plan change the client can make themselves. Canceling in particular has no
 * API of its own (it would mean switching back to the `autopilot-us` signup default), and a
 * change request needs a human to price it, so both route to the concierge instead.
 */
@Component({
    templateUrl: 'edit-subscription.html',
    standalone: false
})

export class EditSubscriptionPage implements OnInit {

  isRightSideContent = true;

  constructor(
    private navCtrl: CustomNavController,
    private rightSidePanelService: RightSidePanelService,
    private storage: TidyStorage,
    private windowService: WindowService
  ) {}

  async ngOnInit() {
    this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
    this.rightSidePanelService.setDialogPageTitle('Edit Subscription');
  }

  requestChanges() {
    this.openChatWithMessage('I\'d like to request a change to my TIDY subscription: ');
  }

  cancelSubscription() {
    this.openChatWithMessage('I\'d like to cancel my TIDY subscription. Reason: ');
  }

  /**
   * Drops the draft into the chat input without sending it, then goes to the chat page.
   *
   * It has to be the localStorage hand-off, not `emitSendMessageAction`: that emits on a
   * plain Subject whose only subscriber is a mounted ExpandableChatComponent, and the chat
   * is only mounted on the chat page itself (and inside bills-content) — so from here the
   * emit went nowhere and the panel just closed. The stash is safe because `chat` is not in
   * CustomRouteReuseStrategy's shouldDetachRoutes, so arriving always runs ngOnInit and with
   * it consumePendingPrefill. It also has to be `chat` specifically: DashboardPage reads and
   * discards the same key without ever binding it.
   */
  private openChatWithMessage(message: string) {
    localStorage.setItem('chatPrefillMessage', message);
    if (this.windowService.isDesktopRes) {
      this.rightSidePanelService.closeRightSidePanel();
    }
    this.navCtrl.navigateForward('chat');
  }
}
